<template>
    <div
        :id="id"
        class="list-wrapper"
    >
        <div class="selection-list">
            <template
                v-for="item in items"
                :key="item.index"
            >
                <InputCheckboxListTile
                    :item="item"
                    :disabled="disabled"
                    :expanded="expanded"
                    :model-value="checked === item.index"
                    @update:model-value="updateModel(item.index)"
                />
            </template>
        </div>
        <ErrorText
            v-if="error"
            :error="error"
        />
    </div>
</template>

<script setup lang="ts">
import InputCheckboxListTile from './InputCheckboxListTile.vue'
import ErrorText from '../ErrorText/ErrorText.vue'

import type { ListTileItem } from './types'
import { onMounted } from 'vue'
import type { BlockPath } from 'widget-components/integrations/CustomPage/types'
import { isNotNil } from 'ramda'

defineOptions({ inheritAttrs: false })

const props = withDefaults(defineProps<{
    id?: string
    items: ListTileItem[]
    error?: string
    disabled?: boolean
    expanded?: boolean
    blockPath?: BlockPath
    initialValue?: number
}>(), {
    items: () => [],
    error: '',
    disabled: false,
    expanded: false,
})


const checked = defineModel<number>({ default: -1 })

const updateModel = (value: number) => {
    checked.value = checked.value === value ? -1 : value
}

onMounted(() => {
    if (isNotNil(props.initialValue)) {
        checked.value = props.initialValue
    }
})
</script>

<style lang="sass" scoped>
@import './InputCheckboxList.sass'
</style>
